
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allQuestionsByRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scenario_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"response"},"name":{"kind":"Name","value":"allQuestionsByRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"role_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"scenario_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scenario_id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scenario_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deciders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tiebreaker"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"day"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minute"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"second"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeout"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"question_category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"direct_message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sender_id_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"answer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"answer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default_for"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":406}};
    doc.loc.source = {"body":"query allQuestionsByRole($role_id: ID!, $scenario_id: ID) {\n\tresponse: allQuestionsByRole(role_id: $role_id, scenario_id: $scenario_id) {\n\t\tid\n\t\tscenario_id\n\t\tdeciders\n\t\tcontributors\n\t\ttiebreaker\n\t\ttype\n\t\tquestion\n\t\tdescription\n\t\tday\n\t\tminute\n\t\tsecond\n\t\ttimer\n\t\ttimeout\n\t\tquestion_category\n\t\tconfig_id\n\t\tdirect_message\n\t\tsender_id_id\n\t\tanswer {\n\t\t\tid\n\t\t\tanswer\n\t\t\tfeedback\n\t\t\timpact\n\t\t\tdefault_for\n\t\t}\n\t}\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["allQuestionsByRole"] = oneQuery(doc, "allQuestionsByRole");
        
